import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type ActionModel from 'frontend/models/action';
import type HeadDataService from 'frontend/services/head-data';

export default class CatalogActionApplyRoute extends Route {
  @service declare headData: HeadDataService;
  @service declare intl: IntlService;

  model() {
    return this.modelFor('catalog.action');
  }

  afterModel(model: ActionModel) {
    this.headData.title = this.intl.t('routes.apply.title', {
      name: model.name,
    });
    this.headData.description = this.intl.t('routes.apply.description', {
      name: model.name,
    });
    this.headData.keywords = this.intl.t('routes.apply.keywords', {
      name: model.name,
    });
    this.headData.noindex = true;
    this.headData.shouldStructuredData = false;
    this.headData.setUrl();
  }
}
